module.exports = __webpack_public_path__ + "static/media/jobsearch.804e3a7c.jpg";